import { createFileRoute } from '@tanstack/react-router'

import { SprintPage } from '@/components/sprints/sprint-page'
import { useFollowProjectClient } from '@/hooks/use-current-client'
import { RETURN_SHAPE } from '@/lib/return-to'
import { readSearch } from '@/lib/search-params'

export const Route = createFileRoute('/_app/projects/$projectRef_/sprints/$sprintId')({
  validateSearch: (search: Record<string, unknown>) => readSearch({ ...RETURN_SHAPE }, search),
  component: SprintRoutePage,
})

function SprintRoutePage() {
  const { projectRef, sprintId } = Route.useParams()
  useFollowProjectClient(projectRef)
  return <SprintPage key={sprintId} projectRef={projectRef} sprintId={sprintId} />
}
